import Immutable from 'immutable';
import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

import { WEBFORM_CATEGORIES_ASSIGNMENTS } from '../../config/constants';
import { getWebformExerciseDetails } from '../../helpers/exercises';
import { TRACK_EVENT, COOKIE_CONSENT_GRANTED } from '../actions/UI';
import { WEBFORM_SUCCESSFUL_SUBMIT } from '../actions/Webform';

/**
 * Track an event with GTM. Default GTM setup will forward the event to GA.
 * @param {object} action - Event attributes.
 * @return {object} GTM event that gets passed to GA.
 */
const genericTrackEvent = (action) => {
  return {
    event: 'Custom event',
    category: action.category,
    action: action.action,
    label: action.label,
    value: action.value,
  };
};

/**
 * Load additional tags from GTM after consent.
 * @return {object} GTM event that triggers loading of additional tags.
 */
const cookieConsentGranted = () => {
  return {
    event: 'Cookie consent granted',
  };
};

/**
 * Track exercise event with GTM.
 * @param {object} action - Event attributes.
 * @param {Immutable.Map} state - The Immutable state.
 * @return {object} GTM event that gets passed to GA.
 */
const trackExerciseEvent = (action, state) => {
  const { id } = action.payload;
  const categories = state.getIn(['webform', id, 'info', 'categories'], Immutable.List());
  const webformIsAssignment = categories.some((category) => WEBFORM_CATEGORIES_ASSIGNMENTS.includes(category));

  if (!webformIsAssignment) {
    return;
  }

  const nodes = state.get('node').toJS();
  const programs = Object.values(nodes).filter((node) => node.type[0].target_id === 'program');
  const {
    currentProgram,
    currentPhase,
    currentExercise,
  } = getWebformExerciseDetails(programs, id);

  if (!currentProgram || !currentPhase || !currentExercise) {
    return;
  }

  return {
    event: 'Track exercise event',
    eventAction: 'finish_assignment',
    eventProgram: currentProgram,
    eventPhase: currentPhase,
    eventExercise: currentExercise,
    eventType: 'submit',
  };
};

// Map events to a Redux actions
const eventsMap = {
  [COOKIE_CONSENT_GRANTED]: cookieConsentGranted,
  [TRACK_EVENT]: genericTrackEvent,
  [WEBFORM_SUCCESSFUL_SUBMIT]: trackExerciseEvent,
};

export default createMiddleware(eventsMap, GoogleTagManager());
